<template>

  <div class="page">
		<div class="gridheader">
			<div class="row">
				<div class="col-md-8 title">
					<h1 class="mrgn">{{ $t('CONTROLPANEL')}}</h1>
					<ul class="list-unstyled">
						<li class="active"><router-link to="/controlpanel/basic">{{ $t('BASICDATA')}}</router-link></li>
						<li><router-link to="/controlpanel/connection">{{ $t('CONNECTINGTOOTHERCOMPANIES')}}</router-link></li>
					</ul>
				</div>
				<div class="col-md-4 action"><a href="#" v-on:click.prevent="saveCompanyData" class="btn btn-primary"><img src="../assets/img/icon-save.svg" alt=""> {{ $t('SAVECHANGES')}}</a></div>
			</div>
		</div>
		<form method="get" action="" class="onpage-form">
      <div class="row borderbottom">
				<div class="col-md-3">
					<div class="form-group" disabled v-bind:class="(formError.notice && formError.notice.companyName) ? 'has-danger' :''">
						<label>{{$t('COMPANYNAME')}}</label>
						<div class="form-control secondary">{{formData.companyName}}</div>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group" disabled v-bind:class="(formError.notice && formError.notice.shortCompanyName) ? 'has-danger' :''">
						<label>{{$t('SHORTCOMPANYNAME')}}</label>
						<div class="form-control secondary">{{formData.shortCompanyName}}</div>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group" disabled v-bind:class="(formError.notice && formError.notice.oib) ? 'has-danger' :''">
						<label>{{$t('OIB')}}</label>
            <div class="form-control secondary">{{formData.oib}}</div>
					</div>
				</div>
        <div class="col-md-3">
  				<div class="form-group" v-bind:class="(formError.notice && formError.notice.email) ? 'has-danger' :''">
  					<label>{{$t('EMAIL')}}</label>
            <div class="form-control secondary">{{formData.email}}</div>
  				</div>
  			</div>
      </div>
      <div class="row">
  			<h2>{{$t('LOCATION')}}</h2>
      </div>
      <div class="row">
				<div class="col-md-3">
					<div class="form-group" v-bind:class="(formError.notice && formError.notice.address) ? 'has-danger' :''">
						<label>{{$t('ADDRESS')}}</label>
						<input type="text" v-model="formData.address" class="form-control secondary" v-bind:placeholder="$t('ADDRESS')">
            <div v-if="formError.notice && formError.notice.address" class="form-control-feedback">{{formError.notice.address}}</div>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group" v-bind:class="(formError.notice && formError.notice.postalNum) ? 'has-danger' :''">
						<label>{{$t('POSTALNUM')}}</label>
						<input type="text" v-model="formData.postalNum" class="form-control secondary" v-bind:placeholder="$t('POSTALNUM')">
            <div v-if="formError.notice && formError.notice.postalNum" class="form-control-feedback">{{formError.notice.postalNum}}</div>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group" v-bind:class="(formError.notice && formError.notice.city) ? 'has-danger' :''">
						<label>{{$t('CITY')}}</label>
						<input type="text" v-model="formData.city" class="form-control secondary" v-bind:placeholder="$t('CITY')">
            <div v-if="formError.notice && formError.notice.city" class="form-control-feedback">{{formError.notice.city}}</div>
					</div>
				</div>
        <div class="col-md-3">
					<div class="form-group" v-bind:class="(formError.notice && formError.notice.country) ? 'has-danger' :''">
						<label>{{$t('COUNTRY')}}</label>
						<input type="text" v-model="formData.country" class="form-control secondary" v-bind:placeholder="$t('COUNTRY')">
            <div v-if="formError.notice && formError.notice.country" class="form-control-feedback">{{formError.notice.country}}</div>
					</div>
				</div>
  		</div>
  		<div class="row">
  			<h2>{{$t('CONTACT')}}</h2>
      </div>
      <div class="row">
  			<div class="col-md-4">
  				<div class="form-group" v-bind:class="(formError.notice && formError.notice.phone) ? 'has-danger' :''">
  					<label>{{$t('PHONE')}}</label>
  					<input type="text" v-model="formData.phone" class="form-control secondary" v-bind:placeholder="$t('PHONE')">
            <div v-if="formError.notice && formError.notice.phone" class="form-control-feedback">{{formError.notice.phone}}</div>
  				</div>
  			</div>
  			<div class="col-md-4">
  				<div class="form-group" v-bind:class="(formError.notice && formError.notice.mobilePhone) ? 'has-danger' :''">
  					<label>{{$t('MOBILEPHONE')}}</label>
  					<input type="text" v-model="formData.mobilePhone" class="form-control secondary" v-bind:placeholder="$t('MOBILEPHONE')">
            <div v-if="formError.notice && formError.notice.mobilePhone" class="form-control-feedback">{{formError.notice.mobilePhone}}</div>
  				</div>
  			</div>
        <div class="col-md-4">
  				<div class="form-group" v-bind:class="(formError.notice && formError.notice.webPage) ? 'has-danger' :''">
  					<label>{{$t('WEBPAGE')}}</label>
  					<input type="text" v-model="formData.webPage" class="form-control secondary" v-bind:placeholder="$t('WEBPAGE')">
            <div v-if="formError.notice && formError.notice.webPage" class="form-control-feedback">{{formError.notice.webPage}}</div>
  				</div>
  			</div>
      </div>
		</form>
	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import companydataApi from '@/api/companydata'

export default {
  name: 'ControlPanel',
  data: function()
  {
    return {
      formData:
      {
        companyName: '',
        shortCompanyName: '',
        oib: '',
        address: '',
        postalNum: '',
        city: '',
        country: '',
        email: '',
        phone: '',
        mobilePhone: '',
        webPage: ''
      },
      formError: {}
    };
  },
  created: function()
  {
    var me = this;
    me.getCompanyData();
  },
  methods:
  {
    getCompanyData: function()
    {
      var me = this;
      companydataApi.getCompanyData({}, function(data)
      {
        me.formData = data.root;
      });
    },
    saveCompanyData: function()
    {
      var me = this;
      companydataApi.saveCompanyData(me.formData, function(val)
      {
        if(val.error)
        {
          me.formError = val;
        }
        else me.formError = {};
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ControlPanel.vue